import { Dialog, DialogTitle } from "@headlessui/react";
import { IconRosetteDiscountCheckFilled } from "@tabler/icons-react";
import Button from "../../../components/Button";

interface SuccessModalProps {
  isOpen: boolean;
  close: () => void;
  textMsg: string;
}

function SuccessModal({ isOpen, close, textMsg }: SuccessModalProps) {
  return (
    <Dialog
      open={isOpen}
      as="div"
      className="relative z-10 focus:outline-none"
      onClose={close}
    >
      <div
        className={"fixed inset-0 z-10 w-screen overflow-y-auto bg-black/50"}
      >
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="w-full max-w-md rounded-lg p-6 bg-white grid gap-6">
            <DialogTitle
              as="h3"
              className="sm:text-[32px] sm:leading-[38px] text-2xl leading-[26px] text-center font-semibold"
            >
              Thank You!
            </DialogTitle>
            <IconRosetteDiscountCheckFilled
              className="text-green-600 mx-auto"
              size={80}
            />
            <p className="sm:text-xl text-lg text-center font-semibold text-gray-600">
              {textMsg}
            </p>
            <Button btnClassName="w-full" onClick={close}>
              OK
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default SuccessModal;
